var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "close-btn", on: { click: _vm.close } }, [
      _c(
        "i",
        { staticClass: "material-icons md-18", attrs: { title: "close" } },
        [_vm._v("close")]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "title" }, [_vm._v("SHARE")]),
    _vm._v(" "),
    _c("div", { staticClass: "px-3 py-2" }, [
      _c("div", { staticClass: "category" }, [
        _c("div", { staticClass: "category-title" }, [_vm._v("LINK")]),
        _vm._v(" "),
        _c("div", { staticClass: "property-row" }, [
          _c("div", { staticClass: "text-description" }, [
            _vm._v(_vm._s(_vm.link))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "pt-2" }, [
            !_vm.copied
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-dark btn-sm",
                    on: { click: _vm.copyLink }
                  },
                  [_vm._v("\n\t\t\t\t\t\tCopy\n\t\t\t\t\t")]
                )
              : _c("button", { staticClass: "btn btn-green btn-sm" }, [
                  _c(
                    "i",
                    {
                      staticClass: "material-icons md-18",
                      staticStyle: { "margin-top": "-3px" }
                    },
                    [_vm._v("assignment_turned_in")]
                  ),
                  _vm._v("\n\t\t\t\t\t\tCopied to clipboard\n\t\t\t\t\t")
                ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3342f7d6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3342f7d6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content-share.vue
// module id = null
// module chunks = 